import { render, staticRenderFns } from "./ThofuConnectView.vue?vue&type=template&id=7c012180"
import script from "./ThofuConnectView.vue?vue&type=script&lang=js"
export * from "./ThofuConnectView.vue?vue&type=script&lang=js"
import style0 from "./ThofuConnectView.vue?vue&type=style&index=0&id=7c012180&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports